/* ============================================================
   SAVRAA — buy nudge  v1.0

   A single re-engagement modal on the product page. Fires on the
   first of: desktop exit-intent, mobile back-gesture intent, or
   40s of inactivity. Once per session, never after add-to-cart.

   Deliberately contains NO fake scarcity: no invented stock counts,
   no countdown timer, no "12 people viewing". Those raise the first
   order and cost you the second one, and in KSA they also raise COD
   refusal rates. Every claim below is one your store actually makes.
   ============================================================ */
(function () {
  'use strict';

  var CFG = {
    idleMs: 40000,
    minOnPageMs: 12000,       // never interrupt someone who just landed
    sessionKey: 'svnudge_shown'
  };

  var T = {
    ar: {
      title: '\u0642\u0628\u0644 \u0623\u0646 \u062a\u063a\u0627\u062f\u0631\u060c \u0623\u0643\u0645\u0644 \u0637\u0644\u0628\u0643',
      sub: '\u0644\u0627 \u062a\u062f\u0641\u0639 \u0634\u064a\u0626\u0627\u064b \u0627\u0644\u0622\u0646 \u2014 \u0627\u0644\u062f\u0641\u0639 \u0639\u0646\u062f \u0627\u0644\u0627\u0633\u062a\u0644\u0627\u0645 \u0641\u0642\u0637.',
      p1: '\u0627\u0644\u062f\u0641\u0639 \u0639\u0646\u062f \u0627\u0644\u0627\u0633\u062a\u0644\u0627\u0645 \u0641\u064a \u062c\u0645\u064a\u0639 \u0623\u0646\u062d\u0627\u0621 \u0627\u0644\u0645\u0645\u0644\u0643\u0629',
      p2: '\u0634\u062d\u0646 \u0633\u0631\u064a\u0639 \u0645\u062c\u0627\u0646\u064a',
      p3: '\u0627\u0644\u0637\u0644\u0628 \u064a\u0633\u062a\u063a\u0631\u0642 \u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629',
      cta: '\u0623\u0643\u0645\u0644 \u0627\u0644\u0637\u0644\u0628',
      dismiss: '\u0644\u0627 \u0634\u0643\u0631\u0627\u064b\u060c \u0623\u0648\u062f \u0645\u062a\u0627\u0628\u0639\u0629 \u0627\u0644\u062a\u0635\u0641\u0651\u062d',
      close: '\u0625\u063a\u0644\u0627\u0642'
    },
    en: {
      title: 'Before you go \u2014 finish your order',
      sub: 'Pay nothing now. Cash on delivery only.',
      p1: 'Cash on delivery across Saudi Arabia',
      p2: 'Fast free shipping',
      p3: 'Takes less than a minute',
      cta: 'Complete order',
      dismiss: 'No thanks, keep browsing',
      close: 'Close'
    }
  };

  function lang(){
    var l = (document.documentElement.getAttribute('lang') || 'en').slice(0,2);
    return T[l] ? l : 'en';
  }

  var L = lang();
  var S = T[L];
  var alt = T[L === 'ar' ? 'en' : 'ar'];

  function shown(){
    try { return sessionStorage.getItem(CFG.sessionKey) === '1'; } catch(e){ return false; }
  }
  function markShown(){
    try { sessionStorage.setItem(CFG.sessionKey, '1'); } catch(e){}
  }

  function productInfo(){
    var main = document.querySelector('main[data-template="product"]');
    if(!main) return null;
    var titleEl = main.querySelector('.product__title h1, h1.product__title, .product__title, h1');
    var imgEl = main.querySelector('.product__media img, .product-media img, img');
    return {
      title: titleEl ? titleEl.textContent.trim() : '',
      image: imgEl ? (imgEl.currentSrc || imgEl.src || '') : ''
    };
  }

  function buyTarget(){
    var main = document.querySelector('main[data-template="product"]');
    if(!main) return null;
    return main.querySelector('.savraa-cod-button')
        || main.querySelector('[class*="cod-button"]')
        || main.querySelector('.product-form__submit:not([disabled])');
  }

  var check = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

  var backdrop, modal, lastFocus;

  function close(){
    if(!modal) return;
    modal.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    setTimeout(function(){
      if(modal && modal.parentNode) modal.parentNode.removeChild(modal);
      if(backdrop && backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
      modal = backdrop = null;
    }, 340);
    if(lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch(e){} }
  }

  function onKey(e){
    if(e.key === 'Escape'){ close(); return; }
    if(e.key !== 'Tab' || !modal) return;
    var f = modal.querySelectorAll('button');
    if(!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  }

  function open(){
    if(shown() || modal) return;
    var p = productInfo();
    if(!p) return;
    markShown();
    lastFocus = document.activeElement;

    backdrop = document.createElement('div');
    backdrop.className = 'svnudge-backdrop';
    backdrop.addEventListener('click', close);

    modal = document.createElement('div');
    modal.className = 'svnudge';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', S.title);

    modal.innerHTML =
      '<button type="button" class="svnudge__close" aria-label="' + S.close + '">' +
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
      '</button>' +
      (p.image ? '<img class="svnudge__media" src="' + p.image + '" alt="" loading="lazy">' : '') +
      '<h2 class="svnudge__title">' + S.title + '</h2>' +
      '<p class="svnudge__sub">' +
        (p.title ? '<span class="svnudge__product">' + p.title + '</span><br>' : '') +
        S.sub +
      '</p>' +
      '<ul class="svnudge__points">' +
        '<li>' + check + '<span>' + S.p1 + '</span></li>' +
        '<li>' + check + '<span>' + S.p2 + '</span></li>' +
        '<li>' + check + '<span>' + S.p3 + '</span></li>' +
      '</ul>' +
      '<button type="button" class="svnudge__cta">' +
        '<span class="svnudge__ar">' + S.cta + '</span>' +
        '<span class="svnudge__sep" aria-hidden="true">|</span>' +
        '<span class="svnudge__en">' + alt.cta + '</span>' +
      '</button>' +
      '<button type="button" class="svnudge__dismiss">' + S.dismiss + '</button>';

    document.body.appendChild(backdrop);
    document.body.appendChild(modal);

    // force reflow so the transition runs
    void modal.offsetWidth;
    backdrop.classList.add('is-open');
    modal.classList.add('is-open');

    modal.querySelector('.svnudge__close').addEventListener('click', close);
    modal.querySelector('.svnudge__dismiss').addEventListener('click', close);
    modal.querySelector('.svnudge__cta').addEventListener('click', function(){
      var target = buyTarget();
      close();
      if(target){
        setTimeout(function(){
          try { target.scrollIntoView({ behavior:'smooth', block:'center' }); } catch(e){}
          setTimeout(function(){ target.click(); }, 320);
        }, 340);
      }
    });

    document.addEventListener('keydown', onKey);
    setTimeout(function(){
      var cta = modal && modal.querySelector('.svnudge__cta');
      if(cta) cta.focus();
    }, 360);
  }

  /* ---------- triggers ---------- */
  function boot(){
    if(!document.querySelector('main[data-template="product"]')) return;
    if(shown()) return;

    var armed = false;
    setTimeout(function(){ armed = true; }, CFG.minOnPageMs);

    // Someone who already added to cart should never see this.
    document.addEventListener('submit', function(e){
      if(e.target && e.target.getAttribute('data-type') === 'add-to-cart-form') markShown();
    }, true);

    // Desktop exit-intent: cursor leaves through the top of the viewport.
    document.addEventListener('mouseout', function(e){
      if(!armed || e.relatedTarget || e.clientY > 8) return;
      open();
    });

    // Idle re-engagement.
    var idleTimer;
    function resetIdle(){
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function(){ if(armed) open(); }, CFG.idleMs);
    }
    ['mousemove','keydown','scroll','touchstart','click'].forEach(function(ev){
      window.addEventListener(ev, resetIdle, { passive: true });
    });
    resetIdle();

    // Mobile: tab hidden then returned \u2014 a common pre-abandon signal.
    document.addEventListener('visibilitychange', function(){
      if(document.visibilityState === 'visible' && armed) open();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
